import {
  useRunLivePollSessionContext,
  useTerminateLivePollSessionMutation,
} from 'src/contexts/runLivePollSessionContext';
import styles from './LivePollSessionHeaderForZoom.module.css';
import { addZoomAppInvitation } from 'src/hooks/store-hooks';
import { sendAppInvitationToAllParticipants } from 'src/utils/zoom-sdk.utils';
import { WuButton, WuModal } from '@npm-questionpro/wick-ui-lib';
import { useState } from 'react';
import { LpToast } from '@livepolls/ui-components/src/components/toast/LpToast';
import { getFourDigitPin } from 'src/utils/FourDigitPin';

export const LivePollSessionHeaderForZoom = () => {
  const [showConfirmPopup, setShowConfirmPopup] = useState<boolean>(false);
  const terminateLivePollSessionMutation =
    useTerminateLivePollSessionMutation();
  const { livePollSession } = useRunLivePollSessionContext();
  const [isError, setIsError] = useState(false);
  const livePollSessionName = livePollSession?.name;
  const pin = livePollSession?.pin;
  const livePollSessionId = livePollSession.id;

  const sendInvitationAddEntryInDatabase = async () => {
    try {
      const response = await sendAppInvitationToAllParticipants();
      const invitationId = response?.invitationId || '';
      const meetingId = response?.meetingId || '';

      if (meetingId) {
        await addZoomAppInvitation(livePollSessionId, invitationId, meetingId);
      }
    } catch (error) {
      setIsError(true);
    }
  };

  const handleConfirmationPopup = () => {
    setShowConfirmPopup(!showConfirmPopup);
  };
  const terminateSession = async () => {
    setShowConfirmPopup(false);
    terminateLivePollSessionMutation.isIdle &&
      (await terminateLivePollSessionMutation.mutateAsync());
  };

  return (
    <div className={styles.container}>
      <WuModal
        open={showConfirmPopup}
        size="sm"
        preventClickOutside={true}
        onOpenChange={handleConfirmationPopup}
        maxWidth="300px"
        maxHeight="175px"
      >
        <div className={styles.infoMessage}>
          Are you sure you want to quit this session?
        </div>
        <div className={styles.buttonRow}>
          <WuButton variant="primary" onClick={terminateSession}>
            Yes
          </WuButton>
        </div>
      </WuModal>
      <div className={styles.header}>
        <div className={styles.livePollSessionName}>
          <div>{livePollSessionName}</div>

          <div className={styles.closeIconContainer}>
            <span
              className={`wm-logout ${styles.closeIcon}`}
              onClick={handleConfirmationPopup}
              aria-label="Terminate session"
            />
          </div>
        </div>
        <div className={styles.pinRow}>
          <div className={styles.pin}>
            <span className={styles.pinText}>PIN: {getFourDigitPin(pin)}</span>{' '}
          </div>
          <div>
            <WuButton
              variant="secondary"
              onClick={() => sendInvitationAddEntryInDatabase()}
            >
              Send invitation
            </WuButton>
          </div>
        </div>
        {isError && (
          <LpToast
            text={'Invitation cannot be sent, Please click on pin to copy'}
            onClose={() => setIsError(false)}
          />
        )}
      </div>
    </div>
  );
};
